/**
 * Enum representing the state of the sidebar.
 * Can be null in case of ignoring actions with sidebar
 */
export enum SidebarState {
  FORCE_OPEN,
  FORCE_CLOSE
}
